/*
  Hero.js
  This is our first big content section.
  It doesn't need any props because all of its animations
  are pure CSS and run on page load.
*/
import React from 'react';
import './Hero.css';

// We import the images we need for the <img> tag
import dandelionImg from '../../../assets/images/Dandelion.png';

// Notice the 'paperRipImg' import line is now GONE.
// This fixes the error.

function Hero() {
  return (
    // This is the main container. The background image (0_1.jpg)
    // is applied via Hero.css
    <section className="hero-section">
      
      {/* 1. The Sun Fade. This is an empty div styled in CSS. */}
      {/* Animation: fadeIn (delay 0.1s) */}
      <div className="hero-sun-fade"></div>

      {/* 2. The Dandelion Graphic */}
      {/* Animation: fadeAndRiseUp (delay 0.3s) */}
      <img 
        src={dandelionImg} 
        alt="Dandelion" 
        className="hero-dandelion" 
      />

      {/* 3. The Title Container */}
      {/* Animation: fadeAndRiseUp (delay 0.3s) */}
      <div className="hero-title-container">
        <h1 className="hero-title-main">Dandelion Run</h1>
        <h2 className="hero-title-sub">Community</h2>
      </div>

      {/* 4. The "Paper Rip" Box */}
      {/* Animation: revealFromLeft (delay 0.7s) */}
      <div className="hero-paper-rip-container">
        <div className="hero-paper-content">
          <h3 className="hero-paper-title">To Run or To Run Away?</h3>
          <p className="hero-paper-text">
            Let’s face it: despite the many benefits of running, many young people 
            develop a negative perception of it and instead...run away
          </p>
        </div>
      </div>

    </section>
  );
}

export default Hero;